import * as React from "react";

export function CallToAction() {
  return (
    <div 
      className="flex gap-3 justify-center items-center self-center mt-14 max-w-full leading-relaxed w-[322px] max-md:mt-10"
      role="button"
      tabIndex={0}
      onClick={() => window.location.href = '/about'}
      onKeyDown={(e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          window.location.href = '/about';
        }
      }}
    >
    </div>
  );
}